module.exports = __webpack_public_path__ + "img/level3addon_dead.f9c801eb.png";